<template>
    <el-card class="box-card">
        <el-row>
            <SearchBox ref="SearchBox">
                <el-form slot="form" :inline="true" ref="searchData" :model="searchParams" label-width="80px"
                         class="unitWidth" size="small">
                    <el-form-item label="所属工厂">
                        <el-select v-model="mechanism.fcCode" placeholder="请选择" :clearable="isclear" :disabled="ischeck"
                                   filterable
                                   @change="fcChange">
                            <el-option v-for="factory in factoryList" :key="factory.value" :label="factory.label"
                                       :value="factory.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属车间">
                        <el-select v-model="mechanism.shopCode" placeholder="请选择" clearable filterable
                                   @change="shopChange">
                            <el-option v-for="shop in shopList" :key="shop.value" :label="shop.label"
                                       :value="shop.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属工段">
                        <el-select v-model="mechanism.sectionCode" placeholder="请选择" clearable filterable
                                   @change="sectionChange">
                            <el-option v-for="section in sectionList" :key="section.value" :label="section.label"
                                       :value="section.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属产线">
                        <el-select v-model="mechanism.lineCode" placeholder="请选择" clearable filterable
                                   @change="lineChange">
                            <el-option v-for="line in lineList" :key="line.value" :label="line.label"
                                       :value="line.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="选择日期">
                        <el-date-picker v-model="mechanism.endTime" type="month" format="yyyy-MM"
                                        placeholder="选择日期"></el-date-picker>
                    </el-form-item>
                    <el-form-item style="margin-left: 20px">
                        <el-button type="primary" @click="getStatistics">查询</el-button>
                        <el-button type="primary" @click="DeviceExcel" style="margin-left: 10px">导出</el-button>
                    </el-form-item>
                </el-form>
            </SearchBox>
        </el-row>
        <el-row>
            <el-tabs type="border-card">
                <el-tab-pane label="点检信息">
                    <div class="tableBox">
                        <el-table stripe ref="multipleTable" :data="twoAnalyze" class="center"
                                  @selection-change="handleSelectionChange" @sort-change="sortChange">
                            <el-table-column prop="createTime" sortable label="月份"/>
<!--                            <el-table-column prop="totalLines" sortable label="总产线数"/>-->
                            <el-table-column prop="numLines" sortable label="点检产线数"/>
<!--                            <el-table-column prop="totalDevices" sortable label="总设备数"/>-->
                            <el-table-column prop="numDevices" sortable label="点检设备数"/>
                            <el-table-column prop="morShiftComp" sortable label="开班完成数"/>
                            <el-table-column prop="morShiftNotComp" sortable label="开班未完成数"/>
                            <el-table-column prop="productComp" sortable label="产品完成数"/>
                        </el-table>
                    </div>
                    <!--<table id="mytable">
                        <thead>
                        <tr>
                            <th>设备编号</th>
                            <th>早班完成数</th>
                            <th>早班未完成数</th>
                            <th>晚班完成数</th>
                            <th>晚班未完成数</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(order, key, index) in twoAnalyze">
                            <td>{{ key }}</td>
                            <td>{{ order.fullCount }}</td>
                            <td>{{ order.notCount }}</td>
                            <td>{{ order.nightFullCount }}</td>
                            <td>{{ order.nightNotCount == 'null' ? '' : order.nightNotCount }}</td>
                        </tr>
                        </tbody>
                    </table>-->
                </el-tab-pane>
                <el-tab-pane label="图表">
                    <div id="main"></div>
                </el-tab-pane>
            </el-tabs>
        </el-row>
    </el-card>
</template>
<script>
    import { getDailyCheckStatistics } from '../../../api/reportform.js'
    import moment from 'moment'

    const { export_json_to_excel } = require('../../vendor_excel/Export2Excel')
    // 引入基本模板
    let echarts = require('echarts/lib/echarts')
    // 引入柱状图组件
    require('echarts/lib/chart/bar')
    // 引入提示框和title组件
    require('echarts/lib/component/tooltip')
    require('echarts/lib/component/title')
    require('echarts/lib/component/legend')
    export default {
        name: 'dailyCheckReport',
        data: function() {
            return {
                mechanism: {
                    fcCode: '',
                    shopCode: '',
                    sectionCode: '',
                    lineCode: '',
                    endTime: new Date()
                },
                searchParams: {
                    pageSize: 10,
                    pageNumber: 1,
                    total: 0,
                    fcCode: '',
                    shopCode: '',
                    sectionCode: '',
                    lineCode: '',
                    devCode: '',
                    sort: '',
                    startTime: '',
                    endTime: ''

                },
                isclear: false,
                factoryData: [],
                access: [],
                role: [],
                ischeck: true,
                scopeDisabled: '',
                factoryTree: [],
                addShow: false,
                userInfo: {},
                fcIdSelected: '',
                twoAnalyze: [],
                dataTime: [],
                excelData: []
            }
        },
        computed: {
            factoryList: function() {
                var arr = []
                var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
                if (this.factoryTree != undefined && this.factoryTree.length > 0) {
                    if (this.ischeck) {
                        for (var i = 0; i < this.factoryTree.length; i++) {
                            for (let j = 0; j < userInfo.roles.length; j++) {
                                if (this.factoryTree[i].deptID == userInfo.roles[j].factoryId) {
                                    arr.push({
                                        label: this.factoryTree[i].deptName,
                                        id: this.factoryTree[i].deptID,
                                        value: JSON.stringify(this.factoryTree[i]),
                                        deptLevel: this.factoryTree[i].deptLevel,
                                        parent: 0
                                    })
                                }
                            }
                        }
                    } else {
                        for (var i = 0; i < this.factoryTree.length; i++) {
                            arr.push({
                                label: this.factoryTree[i].deptName,
                                id: this.factoryTree[i].deptID,
                                value: JSON.stringify(this.factoryTree[i]),
                                deptLevel: this.factoryTree[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            shopList: function() {
                var arr = []
                if (this.mechanism.fcCode != undefined && this.mechanism.fcCode.length > 0) {

                    var factory = JSON.parse(this.mechanism.fcCode)
                    var shops = factory.child
                    for (var i = 0; i < shops.length; i++) {
                        if (shops[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: shops[i].deptName,
                                id: shops[i].deptID,
                                value: JSON.stringify(shops[i]),
                                deptLevel: shops[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            sectionList: function() {
                var arr = []
                if (this.mechanism.shopCode != undefined && this.mechanism.shopCode.length > 0) {
                    var shop = JSON.parse(this.mechanism.shopCode)
                    var vsms = shop.child
                    for (var i = 0; i < vsms.length; i++) {
                        if (vsms[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: vsms[i].deptName,
                                id: vsms[i].deptID,
                                value: JSON.stringify(vsms[i]),
                                deptLevel: vsms[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            lineList: function() {
                var arr = []
                if (this.mechanism.sectionCode != undefined && this.mechanism.sectionCode.length > 0) {
                    var vsm = JSON.parse(this.mechanism.sectionCode)
                    var lines = vsm.child
                    for (var i = 0; i < lines.length; i++) {
                        if (lines[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: lines[i].deptName,
                                id: lines[i].deptID,
                                value: JSON.stringify(lines[i]),
                                deptLevel: lines[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            }
        },
        mounted() {
            this.init()
        },
        methods: {
            init: function() {
                this.access = JSON.parse(sessionStorage.getItem('auths'))
                // this.userInfo = sessionStorage.getItem("userInfo")
                this.userInfo = this.$store.state.userInfo
                var role = this.userInfo.roles
                for (var i = 0; i < role.length; i++) {
                    //所有工厂数据
                    if (role[i].factoryId == 0) {
                        this.ischeck = false
                        this.role = role[i]
                        this.scopeDisabled = false
                        this.isclear = true
                        break
                    } else {
                        if (this.userInfo.factoryId == role[i].factoryId) {
                            this.role = role[i]
                        }
                    }
                }
                this.getFactory()
                this.getData()
            },
            paginationChange(val) {
                this.searchParams.pageSize = val

            },
            paginationCurrentChange(val) {
                this.searchParams.pageNumber = val
            },
            fcChange: function() {
                this.mechanism.shopCode = ''
                this.mechanism.sectionCode = ''
                this.mechanism.lineCode = ''
                this.getStatistics()
            },
            shopChange: function() {
                this.mechanism.sectionCode = ''
                this.mechanism.lineCode = ''
                this.getStatistics()
            },
            sectionChange: function() {
                this.mechanism.lineCode = ''
                this.getStatistics()
            },
            lineChange: function() {
                this.getStatistics()
            },
            getFactory() {
                let queryParams = {
                    fcCode: this.userInfo.fcCode
                }
                let options = {
                    methods: 'GET',
                    url: this.$api.getAllFactory,
                    params: queryParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.factoryData = response.data
                    }
                })
            },
            getData() {
                var self = this
                let options = {
                    method: 'GET',
                    url: this.$api.departTree
                }
                this.$http.request(options).then(response => {
                    this.factoryTree = response.data
                    for (var i = 0; i < self.factoryTree.length; i++) {
                        if (self.factoryTree[i].deptID == self.role.factoryId) {
                            self.mechanism.fcCode = JSON.stringify(self.factoryTree[i])
                        }
                    }
                    this.getStatistics()
                })
            },
            getdatarange: function() {

                if (this.dataTime.length > 0 && this.dataTime[0] != '' && this.dataTime[1] != '') {
                    this.searchParams.startTime = this.dataTime[0]
                    this.searchParams.endTime = this.dataTime[1]
                }
                this.dateRange = this.data
            },
            //多选框选择 返回当前已选行数据(Array)
            handleSelectionChange(val) {
                console.log(val)
            },
            //从后台获取数据,重新排序
            sortChange(val) {
                // 详细文档参考： https://element.eleme.cn/2.13/#/zh-CN/component/table
                console.log(val)
            },
            getStatistics: function() {
                var self = this
                self.searchParams.fcCode = ''
                self.searchParams.shopCode = ''
                self.searchParams.sectionCode = ''
                self.searchParams.lineCode = ''
                if (self.mechanism.fcCode != undefined && self.mechanism.fcCode != '') {
                    self.searchParams.fcCode = JSON.parse(self.mechanism.fcCode).deptCode
                }
                if (self.mechanism.shopCode != undefined && self.mechanism.shopCode != '') {
                    self.searchParams.shopCode = JSON.parse(self.mechanism.shopCode).deptCode
                }
                if (self.mechanism.sectionCode != undefined && self.mechanism.sectionCode != '') {
                    self.searchParams.sectionCode = JSON.parse(self.mechanism.sectionCode).deptCode
                }
                if (self.mechanism.lineCode != undefined && self.mechanism.lineCode != '') {
                    self.searchParams.lineCode = JSON.parse(self.mechanism.lineCode).deptCode
                }
                if (self.mechanism.endTime != undefined && self.mechanism.endTime != '') {
                    self.searchParams.endTime = moment(self.mechanism.endTime).format('YYYY-MM-DD')
                } else {
                    self.mechanism.endTime = moment(new Date()).format('YYYY-MM-DD')
                    self.searchParams.endTime = moment(self.mechanism.endTime).format('YYYY-MM-DD')
                }
                /*if (self.dataTime != null && self.dataTime != '') {
                    if (self.dataTime.length > 0 && self.dataTime[0] != '') {
                        self.searchParams.startTime = self.dataTime[0] + ' 00:00:00'
                        self.searchParams.endTime = self.dataTime[1] + ' 23:59:59'
                    }
                } else {
                    self.searchParams.startTime = self.$moment(new Date()).format('YYYY-MM-DD') + ' 00:00:00'
                    self.searchParams.endTime = self.$moment(new Date()).format('YYYY-MM-DD') + ' 23:59:59'
                }*/
                getDailyCheckStatistics(self.searchParams).then(function(resp) {
                    if (resp.status == 100) {
                        self.twoAnalyze = []
                        if (resp.data != undefined && resp.data != '') {
                            self.twoAnalyze = resp.data
                        } else {
                            self.twoAnalyze = []
                        }
                        var option = self.creatObject()
                        if (undefined == self.twoAnalyze || self.twoAnalyze == null) {
                            return
                        }
                        option.legend = {
                            show: true,
                            data: [/*'总产线数',*/ '点检产线数', /*'总设备数',*/ '点检设备数', '开班完成数', '开班未完成数', '产品完成数'],
                            selected: {
                                /*'总产线数': true,*/
                                '点检产线数': true,
                                /*'总设备数': true,*/
                                '点检设备数': true,
                                '开班完成数': true,
                                '开班未完成数': true,
                                '产品完成数': true
                            }
                        }
                        option.series = [
                            /*{ name: '总产线数', type: 'bar', data: [] },*/
                            { name: '点检产线数', type: 'bar', data: [] },
                            /*{ name: '总设备数', type: 'bar', data: [] },*/
                            { name: '点检设备数', type: 'bar', data: [] },
                            { name: '开班完成数', type: 'bar', data: [] },
                            { name: '开班未完成数', type: 'bar', data: [] },
                            { name: '产品完成数', type: 'bar', data: [] }
                        ]
                        for (let key in self.twoAnalyze) {
                            option.xAxis[0].data.push(self.twoAnalyze[key].createTime)
                            /*option.series[0].data.push(self.twoAnalyze[key].totalLines)*/
                            option.series[0].data.push(self.twoAnalyze[key].numLines)
                            /*option.series[2].data.push(self.twoAnalyze[key].totalDevices)*/
                            option.series[1].data.push(self.twoAnalyze[key].numDevices)
                            option.series[2].data.push(self.twoAnalyze[key].morShiftComp != 'null' ? self.twoAnalyze[key].morShiftComp : '')
                            option.series[3].data.push(self.twoAnalyze[key].morShiftNotComp != 'null' ? self.twoAnalyze[key].morShiftNotComp : '')
                            option.series[4].data.push(self.twoAnalyze[key].productComp != 'null' ? self.twoAnalyze[key].productComp : '')
                        }
                    } else {
                        self.twoAnalyze = []
                    }
                    self.drawLine(option)
                })
            },
            drawLine(option) {
                // 基于准备好的dom，初始化echarts实例
                let myChart = echarts.init(document.getElementById('main'))
                // 绘制图表
                myChart.setOption(option)
            },
            creatObject: function() {
                var option = {
                    title: { text: '点检分析' },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                        }
                    },
                    toolbox: {
                        show: true,
                        orient: 'vertical',
                        x: 'right',
                        y: 'center',
                        feature: {
                            mark: { show: true },
                            dataView: { show: true, readOnly: false },
                            magicType: { show: true, type: ['line', 'bar', 'stack', 'tiled'] },
                            restore: { show: true },
                            saveAsImage: { show: true }
                        }
                    },
                    grid: {
                        left: '10%',
                        bottom: '35%'
                    },
                    calculable: true,
                    xAxis: [{
                        type: 'category',
                        data: [],
                        axisLabel: {
                            interval: 0,//横轴信息全部显示
                            rotate: 40//-30度角倾斜显示
                        },
                        boundaryGap: ['20%', '20%']
                    }],
                    yAxis: [{
                        type: 'value',
                        axisLabel: {
                            show: true,
                            interval: 'auto',
                            formatter: '{value}'
                        },
                        show: true
                    }]
                }
                return option
            },
            DeviceExcel: function() {
                var self = this
                self.excelData = []
                for (var key in self.twoAnalyze) {
                    var data = {
                        createTime: self.twoAnalyze[key].createTime,
                        numLines: self.twoAnalyze[key].numLines,
                        totalLines: self.twoAnalyze[key].totalLines,
                        numDevices: self.twoAnalyze[key].numDevices,
                        totalDevices: self.twoAnalyze[key].totalDevices,
                        morShiftComp: self.twoAnalyze[key].morShiftComp,
                        morShiftNotComp: self.twoAnalyze[key].morShiftNotComp,
                        productComp: self.twoAnalyze[key].productComp
                    }
                    self.excelData.push(data)
                }
                self.DeviceExport()
            },
            formatJson: function(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            DeviceExport: function() {
                const tHeader = ['月份', '总产线数', '保养产线数', '总设备数', '保养设备数', '开班完成数', '开班未完成数', '产品完成数']
                const filterVal = ['createTime', 'numLines', 'totalLines', 'numDevices', 'totalDevices', 'morShiftComp', 'morShiftNotComp', 'productComp']
                export_json_to_excel(tHeader, this.formatJson(filterVal, this.excelData), '点检统计')
            }
        }
    }
</script>
<style lang="scss" scoped>
    #main {
        width: 1200px;
        height: 700px;
    }

    .box-card {
        // width: 70%;
    }

    #mytable {
        border: 1px solid #e4e5e6;
        padding: 0;
        margin: 0;
        border-collapse: collapse;
    }

    table {
        width: 100%;
    }

    th {
        width: 5vw;
        height: 3vw;
        border-bottom: 1px solid #e4e5e6;
        background-color: #eef3ff;
    }

    td {
        border-right: 1px solid #e4e5e6;
        border-bottom: none;
        font-size: 11px;
        padding: 6px 6px 6px 12px;
        color: #4f6b72;
    }

    td.alt {
        background: #f5fafa;
        color: #797268;
    }
</style>
